import { LineChart, UniDatePicker, UniDateRangePicker } from '@/components'
import AddDataNode from './addDataNode'
import ShowAlarmEvent from '../showAlarmEvent'
import HandleAlarmEventModal from '../handleAlarmEventModal'
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getTodayBeginAndEndDate, getOneWeekBeginAndEndDate, getYear, getMonth} from '@/utils/date'
import {getEncoderList} from '@/api/get-data.js'

export default {
  name: 'ShowDataNode',
  data () {
    return {
      playType: 2, // 播放类型，0-rtmp,1-hls,2-http-flv
      playerManager: null,
      player: null,
      // 遮罩层
      loading: false,
      imageFileName: '/static/img/device/icon_device_temperature_128.png',
      tableData: [{
        '1': '名称',
        '2': this.dataNode.name,
        '3': '传感器种类',
        '4': this.$type.getResourceSubTypeNameById(this.dataNode.resourceKind, this.dataNode.gaugedObjectKind)
      }, {
        '1': '信号种类',
        '2': this.getNameById(this.dataNode.resourceKind, this.$type.resourceKinds),
        '3': '通道号',
        '4': this.dataNode.deviceInputNum
      }, {
        '1': '数值',
        '2': this.$type.getResourceWorkStateText(this.dataNode.resourceKind, this.dataNode.gaugedObjectKind, this.dataNode.guagedValue, this.dataNode.realValue, this.dataNode.scaleFactor, this.dataNode.correctedValue, this.dataNode.valueType, this.dataNode.decimalDigit, this.dataNode.dataUnit),
        '3': '数值更新时间',
        '4': this.strDateTimeFromSTime_t(this.dataNode.guagedTime)
      }, {
        '1': '告警状态',
        '2': this.$type.getResourceAlarmStateText(this.dataNode.resourceKind, this.dataNode.alarmState, this.dataNode.eventTypeSet, this.dataNode.deployed, this.dataNode.encoderAlarmState, this.dataNode.encoderEventTypeSet),
        '3': '事件类型',
        '4': this.$type.getEventTypeNameById(this.dataNode.resourceKind, this.dataNode.eventTypeSet)
      }, {
        '1': '事件子类型',
        '2': this.$type.getEventSubTypeNameById(this.dataNode.resourceKind, this.dataNode.gaugedObjectKind, this.dataNode.eventTypeSet, this.dataNode.eventSubTypeSet),
        '3': '事件触发时间',
        '4': this.strDateTimeFromSTime_t(this.dataNode.happenTime)
      }, {
        '1': '接入监控设备',
        '2': '',
        '3': '所属区域',
        '4': this.getNameById(this.dataNode.regionId, this.$globalData.regions)
      }],
      activeTabName: '0',
      // 实时数据页面--------------------------------------------------------------------------------------------------
      dataTableData: [],
      dataLineChartId: 'data-line-chart',
      dataLineChartData: [['', '数据节点数值']], // xAxis-时间，yAxis-数据节点数值
      dataLineChartColor: ['#4CA2EB'],
      dataDates: [],
      dataTableQueryParams: {
        regionId: 0,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        beginReportDateTime: 0,
        endReportDateTime: 0,
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 8
      },
      // 历史数据页面--------------------------------------------------------------------------------------------------
      historyDataTableData: [],
      historyDataTableTotalRow: 0,
      historyDataLineChartId: 'history-data-line-chart',
      historyDataLineChartData: [['', '数据节点数值']], // xAxis-时间，yAxis-数据节点数值
      historyDataLineChartColor: ['#4CA2EB'],
      historyDataDate: null,
      historyDataTableQueryParams: {
        regionId: 0,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        beginReportDateTime: 0,
        endReportDateTime: 0,
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 6
      },
      // 增加数据节点弹窗
      addDataNodeModalOpen: false,
      addDataNodes: [],
      // 事件记录页面--------------------------------------------------------------------------------------------------
      eventTableData: [],
      eventTableTotalRow: 0,
      maxEventRowId: 0,
      eventDates: [],
      eventTableQueryParams: {
        lastEventId: 0,
        regionId: 0,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 7
      },
      // 表格选中记录数组
      eventTableSelectedIds: [],
      // 事件表格当前行
      eventTableCurrentRow: null,
      // 事件信息弹窗
      showEventModalOpen: false,
      // 处理告警事件弹窗
      handelAlarmEventModalOpen: false,
      // 统计分析页面--------------------------------------------------------------------------------------------------
      statisticsLineChartId: 'statistics-line-chart',
      statisticsLineChartData: [['', '最小值', '', '最大值', '', '平均值']], // xAxis-时间，yAxis-数据节点平均值/最大值/最小值
      statisticsLineChartColor: ['#41CF87', '#FFA03A', '#4CA2EB'],
      statisticsLineChartQueryParams: {
        regionId: 0,
        nodeId: 0,
        year: getYear(),
        month: getMonth(),
        pageNum: 1,
        pageSize: 8
      },
      pollingTimer: null
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    dataNode: {
      type: Object,
      default: {}
    }
  },
  components: {
    LineChart,
    UniDatePicker,
    UniDateRangePicker,
    AddDataNode,
    ShowAlarmEvent,
    HandleAlarmEventModal
  },
  mixins: [
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  created() {
  },
  mounted () {
    // 加载节点图像
    this.imageFileName = this.deviceImage128FileNameByResourceKindAndSubType(this.dataNode.resourceKind, this.dataNode.gaugedObjectKind)

    // 实时数据页面--------------------------------------------------------------------------------------------------
    // 设置查询起始日期和截止日期
    this.dataDates = getTodayBeginAndEndDate() // 今天
    this.dataLineChartData = [['', '数据节点数值']]
    this.dataLineChartData[0][1] = this.dataNode.name
    if (this.dataNode.dataUnit.length > 0) {
      this.dataLineChartData[0][1] += '(' + this.dataNode.dataUnit + ')'
    }
    // 历史数据页面--------------------------------------------------------------------------------------------------
    // 设置查询起始日期和截止日期
    this.historyDataDate = new Date()

    // 事件记录页面--------------------------------------------------------------------------------------------------
    // 设置查询起始日期和截止日期
    this.eventDates = getOneWeekBeginAndEndDate() // 近一周

    // 统计分析页面--------------------------------------------------------------------------------------------------

    // 查询监控设备列表
    this.getEncoderList2()
    // 开始数据轮巡
    this.startDataPolling()
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()

    // 实时数据页面--------------------------------------------------------------------------------------------------
    // 历史数据页面--------------------------------------------------------------------------------------------------
    // 事件记录页面--------------------------------------------------------------------------------------------------
  },
  methods: {
    // 查询监控设备列表
    getEncoderList2() {
      getEncoderList(() => {
        this.tableData[5]['2'] = this.getNameById(this.dataNode.deviceId, this.$globalData.encoders)
      })
    },
    // 查询数值列表
    getDataList() {
      this.loading = true
      this.dataTableQueryParams.objectId = this.dataNode.id
      this.dataTableQueryParams.beginReportDateTime = this.dataDates[0].getTime() / 1000
      this.dataTableQueryParams.endReportDateTime = this.dataDates[1].getTime() / 1000
      this.$http(this.$api.historyDataList, this.dataTableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.dataTableData = res.data

            // 绘制line
            if (res.data.length) {
              let dataLineChartData2 = this.dataLineChartData[0]
              this.dataLineChartData = []
              this.dataLineChartData.push(dataLineChartData2)
              res.data.forEach(item => {
                let yItem = []
                yItem.push(new Date(item.reportTime * 1000))
                yItem.push(item.latestValue)
                this.dataLineChartData.push(yItem)
              })
            }
            this.$nextTick(() => {
              if (this.$refs.dataLineChart) {
                this.$refs.dataLineChart.draw()
              }
            })
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询历史数值列表
    getHistoryDataList() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.historyDataTableQueryParams.objectId = this.dataNode.id
        // 生成起始和结束日期数组
        let beginDateTime = new Date(this.historyDataDate.Format('yyyy-MM-dd') + ' 00:00:00')
        let endDateTime = new Date(this.historyDataDate.Format('yyyy-MM-dd') + ' 23:59:59')
        this.historyDataTableQueryParams.beginReportDateTime = beginDateTime.getTime() / 1000
        this.historyDataTableQueryParams.endReportDateTime = endDateTime.getTime() / 1000
        this.$http(this.$api.historyDataList, this.historyDataTableQueryParams).then(
          res => {
            if (res.code === 200) {
              this.historyDataTableData = res.data
              this.historyDataTableTotalRow = res.page.totalRow
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询历史数值列表For图表
    getHistoryDataListForChart() {
      this.loading = true
      if (this.addDataNodes.length > 0) {
        if (this.historyDataTableQueryParams.objectId) {
          delete this.historyDataTableQueryParams.objectId
        }
        this.historyDataTableQueryParams.objectIds = this.addDataNodes.map(item => item.id)
        this.historyDataTableQueryParams.objectIds.push(this.dataNode.id)
      } else {
        if (this.historyDataTableQueryParams.objectIds) {
          delete this.historyDataTableQueryParams.objectIds
        }
        this.historyDataTableQueryParams.objectId = this.dataNode.id
      }
      // 生成起始和结束日期数组
      let beginDateTime = new Date(this.historyDataDate.Format('yyyy-MM-dd') + ' 00:00:00')
      let endDateTime = new Date(this.historyDataDate.Format('yyyy-MM-dd') + ' 23:59:59')
      this.historyDataTableQueryParams.beginReportDateTime = beginDateTime.getTime() / 1000
      this.historyDataTableQueryParams.endReportDateTime = endDateTime.getTime() / 1000
      let oldPageSize = this.historyDataTableQueryParams.pageSize
      this.historyDataTableQueryParams.pageSize = 1000
      this.$http(this.$api.historyDataList, this.historyDataTableQueryParams).then(
        res => {
          if (res.code === 200) {
            // 绘制line
            if (res.data.length) {
              this.historyDataLineChartData = []
              if (this.addDataNodes.length > 0) { // 多节点
                let dataNodeValuess = []
                let maxValueCount = 0
                this.historyDataLineChartData.push([])
                if (this.addDataNodes.findIndex((item) => item.id === this.dataNode.id) < 0) {
                  this.addDataNodes.push(this.dataNode)
                }
                for (let i = 0; i < this.addDataNodes.length; ++i) {
                  let dataNode = this.addDataNodes[i]
                  let chartLengend = dataNode.name
                  if (dataNode.dataUnit.length > 0) {
                    chartLengend += '(' + dataNode.dataUnit + ')'
                  }
                  this.historyDataLineChartData[0].push('')
                  this.historyDataLineChartData[0].push(chartLengend)

                  let dataNodeValues = []
                  for (let j = 0; j < res.data.length; ++j) {
                    if (dataNode.id === res.data[j].resourceId) {
                      dataNodeValues.push(new Date(res.data[j].reportTime * 1000))
                      dataNodeValues.push(res.data[j].latestValue)
                    }
                  }
                  if (maxValueCount < dataNodeValues.length / 2) {
                    maxValueCount = dataNodeValues.length / 2
                  }
                  dataNodeValuess.push(dataNodeValues)
                }

                let yItem = []
                for (let i = 0; i < maxValueCount; ++i) {
                  yItem = []
                  for (let j = 0; j < dataNodeValuess.length; ++j) {
                    if (dataNodeValuess[j].length > i * 2) {
                      yItem.push(new Date(dataNodeValuess[j][i * 2]))
                      yItem.push(dataNodeValuess[j][i * 2 + 1])
                    } else {
                      yItem.push(new Date(dataNodeValuess[j][dataNodeValuess[j].length - 2]))
                      yItem.push(dataNodeValuess[j][dataNodeValuess[j].length - 1])
                    }
                  }
                  this.historyDataLineChartData.push(yItem)
                }
              } else { // 单节点
                this.historyDataLineChartData = [['', '数据节点数值']]
                this.historyDataLineChartData[0][1] = this.dataNode.name
                if (this.dataNode.dataUnit.length > 0) {
                  this.historyDataLineChartData[0][1] += '(' + this.dataNode.dataUnit + ')'
                }
                res.data.forEach(item => {
                  let yItem = []
                  yItem.push(new Date(item.reportTime * 1000))
                  yItem.push(item.latestValue)
                  this.historyDataLineChartData.push(yItem)
                })
              }
            }
            this.$nextTick(() => {
              if (this.$refs.historyDataLineChart) {
                this.$refs.historyDataLineChart.draw()
              }
            })
          }
          this.historyDataTableQueryParams.pageSize = oldPageSize
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.historyDataTableQueryParams.pageSize = oldPageSize
        this.loading = false
      })
    },
    // 查询事件列表
    getEventList() {
      this.loading = true
      this.eventTableQueryParams.objectId = this.dataNode.id
      this.eventTableQueryParams.beginHappenDateTime = this.eventDates[0].getTime() / 1000
      this.eventTableQueryParams.endHappenDateTime = this.eventDates[1].getTime() / 1000
      this.$http(this.$api.historyEventList, this.eventTableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.eventTableData = res.data
            this.eventTableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询最值统计列表
    getTheMostValueStatList() {
      this.loading = true
      this.statisticsLineChartQueryParams.regionId = this.dataNode.regionId
      this.statisticsLineChartQueryParams.nodeId = this.dataNode.id
      this.$http(this.$api.theMostValueStatList, this.statisticsLineChartQueryParams).then(
        res => {
          if (res.code === 200) {
            // 绘制line
            this.statisticsLineChartData = [['', '最小值', '', '最大值', '', '平均值']]
            if (res.data.length) {
              let statisticsLineChartData2 = this.statisticsLineChartData[0]
              this.statisticsLineChartData = []
              this.statisticsLineChartData.push(statisticsLineChartData2)
              let beginDate = new Date()
              beginDate.setDate(1) // 从当月1日开始
              for (let i = 1; i <= res.data[0].maxDayCount; ++i) {
                if (res.data[0]['minValue' + i] < -300000000 + 2 || res.data[0]['maxValue' + i] > 300000000 - 2) { // 确认已做过统计
                  continue
                }
                let yItem = []
                yItem.push(new Date(beginDate.getTime() + 3600 * 1000 * 24 * (i - 1)))
                yItem.push(res.data[0]['minValue' + i])
                yItem.push(new Date(beginDate.getTime() + 3600 * 1000 * 24 * (i - 1)))
                yItem.push(res.data[0]['maxValue' + i])
                yItem.push(new Date(beginDate.getTime() + 3600 * 1000 * 24 * (i - 1)))
                yItem.push(res.data[0]['avgValue' + i])
                this.statisticsLineChartData.push(yItem)
              }
            }
            this.$nextTick(() => {
              if (this.$refs.statisticsLineChart) {
                this.$refs.statisticsLineChart.draw()
              }
            })
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 开始数据轮巡
    startDataPolling() {
      // 先执行一次
      if (this.activeTabName === '0') {
        this.getDataList()
      } if (this.activeTabName === '1') {
      } else if (this.activeTabName === '2') {
        // this.getEventList()
      } else if (this.activeTabName === '3') {
        // this.getTheMostValueStatList()
      }

      this.pollingTimer = setInterval(() => {
        if (!this.modalOpen) {
          return
        }
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        if (this.activeTabName === '0') {
          this.getDataList()
        } if (this.activeTabName === '1') {
        } else if (this.activeTabName === '2') {
          // this.getEventList()
        } else if (this.activeTabName === '3') {
          // this.getTheMostValueStatList()
        }
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    handleTableCellStyleChange(row) {
      if (row.columnIndex === 0 || row.columnIndex === 2) { // 列1和列3为标题
        return 'background:#FAFAFA;color:#333333;font-weight: bold'
      } else {
        return ''
      }
    },
    handleTableCellClassChange(row) {
      if (row.columnIndex === 1 && row.rowIndex === 3) { // 告警状态数值位于2列4行
        return this.colorClassFromResourceAlarmState(this.dataNode.resourceKind, this.dataNode.alarmState, this.dataNode.eventTypeSet, this.dataNode.deployed,
          this.dataNode.encoderAlarmState, this.dataNode.encoderEventTypeSet)
      } else {
        return ''
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      if (tab.name === '0') {
      } else if (tab.name === '1') {
        if (this.historyDataTableData.length === 0) {
          this.getHistoryDataList().then(res => {
            this.getHistoryDataListForChart()
          })
        }
      } else if (tab.name === '2') {
        if (this.eventTableTotalRow === 0) {
          this.getEventList()
        }
      } else if (tab.name === '3') {
        this.getTheMostValueStatList()
      }
    },
    // 历史数据页面--------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleHistoryDataFormQuery() {
      this.historyDataTableQueryParams.pageNum = 1
      this.getHistoryDataList().then(res => {
        this.getHistoryDataListForChart()
      })
    },
    // 前一天查询按钮操作
    handlePriorDayHistoryDataFormQuery() {
      this.historyDataDate = new Date(this.historyDataDate.setDate(this.historyDataDate.getDate() - 1))
      this.historyDataTableQueryParams.pageNum = 1
      this.getHistoryDataList().then(res => {
        this.getHistoryDataListForChart()
      })
    },
    // 后一天查询按钮操作
    handleNextDayHistoryDataFormQuery() {
      this.historyDataDate = new Date(this.historyDataDate.setDate(this.historyDataDate.getDate() + 1))
      this.historyDataTableQueryParams.pageNum = 1
      this.getHistoryDataList().then(res => {
        this.getHistoryDataListForChart()
      })
    },
    // 重置按钮操作
    resetHistoryDataQueryForm() {
      this.historyDataTableQueryParams.regionId = 0
      this.historyDataTableQueryParams.objectId = 0
      this.historyDataTableQueryParams.descendantRegionRequired = 1
      this.historyDataTableQueryParams.resourceKind = 255
      this.historyDataTableQueryParams.resourceSubType = 255
      this.historyDataDate = new Date() // 今天
      this.historyDataTableQueryParams.beginReportDateTime = 0
      this.historyDataTableQueryParams.endReportDateTime = 0
      this.historyDataTableQueryParams.pageNum = 1
      this.$refs['historyDataQueryForm'].resetFields()
      this.addDataNodes = []
      this.handleHistoryDataFormQuery()
    },
    // 分页
    handleHistoryDataCurrentPageChange(val) {
      this.historyDataTableQueryParams.pageNum = val
      this.getHistoryDataList()
    },
    // 页面条数改变
    handleHistoryDataPageSizeChange(val) {
      this.historyDataTableQueryParams.pageSize = val
      this.getHistoryDataList()
    },
    // 增加对比用数据节点弹窗
    handleAddDataNode() {
      this.addDataNodeModalOpen = true
    },
    // 增加对比用数据节点提交
    handleAddDataNodeModalSubmit(val) {
      this.addDataNodeModalOpen = false
      this.addDataNodes = val.dataNodes
      this.getHistoryDataListForChart()
    },
    // 增加对比用数据节点取消提交
    handleAddDataNodeModalCancel() {
      this.addDataNodeModalOpen = false
    },
    // 事件记录页面--------------------------------------------------------------------------------------------------
    // 分页
    handleEventCurrentPageChange(val) {
      this.eventTableQueryParams.pageNum = val
      this.getEventList()
    },
    // 页面条数改变
    handleEventPageSizeChange(val) {
      this.eventTableQueryParams.pageSize = val
      this.getEventList()
    },
    // 表格选中记录改变
    handleEventTableSelectionChange(selection) {
      this.eventTableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleEventTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.eventTableCurrentRow = currentRow
    },
    // 查看事件
    handleEventView(row) {
      if (row && row.id) {
        this.$refs.dataNodeEventTable.setCurrentRow(row) // 选中当前行
        this.showEventModalOpen = true
      }
    },
    // 处理事件
    handleEventHandle(row) {
      if (row && row.id) {
        this.$refs.dataNodeEventTable.setCurrentRow(row) // 选中当前行
        this.handelAlarmEventModalOpen = true
      } else if (this.eventTableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定批量确认选中的' + this.eventTableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.confirmAlarm, {
            eventIds: this.eventTableSelectedIds,
            handleIdea: ''
          }).then(res => {
            if (res.code === 200) {
              this.getHistoryEventList()
              this.$message({
                type: 'success',
                message: '提交成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '提交失败!'
              })
            }
          })
        })
      }
    },
    // 处理显示告警事件弹窗提交
    handleShowEventModalSubmit() {
      this.showEventModalOpen = false
      this.eventTableCurrentRow.handled = 1
    },
    // 处理显示告警事件弹窗取消提交
    handleShowEventModalCancel() {
      this.showEventModalOpen = false
    },
    // 处理告警事件弹窗提交
    handleHandleAlarmEventModalSubmit() {
      this.handelAlarmEventModalOpen = false
      this.eventTableCurrentRow.handled = 1
    },
    // 处理告警事件弹窗取消提交
    handleHandleAlarmEventModalCancel() {
      this.handelAlarmEventModalOpen = false
    },
    // 取消提交记录
    handleModalCancel () {
      this.$emit('cancel', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/showDataNode/ShowDataNode.js